import { lazy } from "react";
import { Outlet, Routes } from "react-router";
import { Route, useParams } from "react-router-dom";
import AuthGuard from "~Common/ProtectedRoute";
import { NotFoundPage } from "~pages/ErrorPages";
import { NavTabs } from "./components/NavTabs.tsx";
import useGetSeasonTabRoutes from "./hooks/useGetSeasonTabRoutes.tsx";

const ManageSeasonWrapper = lazy(() => import("~Features/Season/ManageSeasonWrapper"));

const SeasonTabsRoutes = () => {
  const { customerId, sport, organizationId, seasonId } = useParams();
  const routes = useGetSeasonTabRoutes();

  const baseUrl = `/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}`;

  return (
    <Routes>
      <Route
        element={
          <ManageSeasonWrapper>
            <NavTabs routes={routes} baseUrl={baseUrl} />
            <Outlet />
          </ManageSeasonWrapper>
        }
      >
        {routes.map(({ Component, permissionKey, key, path }) => (
          <Route
            key={key}
            path={path}
            element={
              <AuthGuard permissionKey={permissionKey}>
                <Component />
              </AuthGuard>
            }
          />
        ))}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default SeasonTabsRoutes;
